// NewExpense.jsx
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import useAuthStore from "../../services/authStore";
import { toastSuccess, toastError, toastWarning } from "../../services/toaster";
import "./NewExpense.css";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";

import { FaChevronDown } from "react-icons/fa";
const API_URL = process.env.REACT_APP_API_URL;

const emptyRow = {
  expense_type_id: "",
  description: "",
  date: "",
  amount: "",
  gl_code: "",
  currency: "",
  attachment: null,
};

export default function NewExpense() {
  // ================= STORE =================
  const [loading, setLoading] = useState(false);
  const token = useAuthStore((s) => s.token);
  const companyId = useAuthStore((s) => s.companyId);
  const userId = useAuthStore((s) => s.user_id);
  const department = useAuthStore((s) => s.department);
  const grade = useAuthStore((s) => s.grade);
  const currency = useAuthStore((s) => s.currency);
  const location = useAuthStore((s) => s.location);
  const integrationBaseUrl = useAuthStore((s) => s.integrationBaseUrl);
  const employeeCode = useAuthStore((s) => s.employee_code);
  const tableRef = useRef(null);
  const navigate = useNavigate();
  // ================= STATE =================
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [approvalMatrix, setApprovalMatrix] = useState([]);
  const [lines, setLines] = useState([{ ...emptyRow }]);
  const [files, setFiles] = useState([]);
  const [purpose, setPurpose] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [expenseGradeLimits, setExpenseGradeLimits] = useState([]);
  const currencyOptions = ["INR", "USD", "EUR", "AED"];
  const [hasMatrixAccess, setHasMatrixAccess] = useState(true);
  const [allowDaysLimit, setAllowDaysLimit] = useState(null);
  const [openCategoryRow, setOpenCategoryRow] = useState(null);
  const [categorySearch, setCategorySearch] = useState("");
  const [selectedExpenseType, setSelectedExpenseType] = useState("");
  const [cashModulePermission, setCashModulePermission] = useState(false);
  const [cashPermissionLoading, setCashPermissionLoading] = useState(true);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [advanceList, setAdvanceList] = useState([]);
  const [selectedAdvanceIds, setSelectedAdvanceIds] = useState([]);
  const [cashBalance, setCashBalance] = useState(null);
  const [cashBalanceLoading, setCashBalanceLoading] = useState(false);
  const [returnAmountError, setReturnAmountError] = useState("");
  const [returnAmountErrorRow, setReturnAmountErrorRow] = useState(null);
  // const [cashBalanceError, setCashBalanceError] = useState("");
  const submitLock = useRef(false);

  const expenseRequestTypes = [
    {
      value: "expense_claim",
      label: "🧾 Expense Claim",
      description: "Submit bills and claim reimbursement for expenses you paid",
    },

    ...(cashModulePermission
      ? [
          {
            value: "advanced_request_cash",
            label: "💵 Petty Cash",
            description: "Draw and track small day-to-day cash expenses",
          },
        ]
      : []),

    {
      value: "advanced_request_bank",
      label: "🏦  Advance Request",
      description: "Request funds in advance for upcoming business needs",
    },
    {
      value: "expense_claim_against_apr",
      label: "📋 Advance Settlement",
      description: "Submit bills against an advance and close out the balance",
    },
    {
      value: "return_again_advanced",
      label: "↩️ Advance Refund",
      description: "Return the unused balance from an advance",
    },
  ];

  const expenseTypeCodeMap = {
    expense_claim: "EC",
    advanced_request_cash: "PT",
    advanced_request_bank: "BT",
    expense_claim_against_apr: "ECAA",
    return_again_advanced: "RAA",
  };
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       dropdownRef.current &&
  //       !dropdownRef.current.contains(event.target) &&
  //       selectRef.current &&
  //       !selectRef.current.contains(event.target)
  //     ) {
  //       setOpenCategoryRow(null);
  //       setCategorySearch("");
  //     }
  //   };

  //   document.addEventListener("click", handleClickOutside);

  //   return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //   };
  // }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target;
      // If click is inside either a select-box or a dropdown, keep it open
      if (
        target.closest(".custom-select-box") ||
        target.closest(".custom-dropdown")
      ) {
        return;
      }
      // Otherwise close the dropdown and clear search
      setOpenCategoryRow(null);
      setCategorySearch("");
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const formatNotificationTime = () => {
    return new Date().toLocaleString("sv-SE", {
      timeZone: "Asia/Kolkata",
    });
  };
  useEffect(() => {
    if (!companyId || !token) return;

    fetch(`${API_URL}/expense-type/${companyId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const list = Array.isArray(data) ? data : data?.data || [];

        const activeExpenseTypes = list.filter(
          (item) => Number(item.isactive) === 1,
        );

        setExpenseTypes(activeExpenseTypes);
      })
      .catch(console.error);
  }, [companyId, token]);
  useEffect(() => {
    if (!companyId || !userId || !token) return;

    const checkCashModulePermission = async () => {
      try {
        setCashPermissionLoading(true);

        const response = await axios.get(
          `${API_URL}/cash-module-permission/${companyId}/user/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const isPermission =
          response?.data?.is_permission === true ||
          Number(response?.data?.is_permission) === 1;

        setCashModulePermission(isPermission);
      } catch (error) {
        console.error("Cash module permission API failed:", error);

        // If API fails, don't show Advanced Request Cash
        setCashModulePermission(false);
      } finally {
        setCashPermissionLoading(false);
      }
    };

    checkCashModulePermission();
  }, [companyId, userId, token]);
  const Regenerated_expireToken = useAuthStore(
    (s) => s.Regenerated_expireToken,
  );
  const formatAmount = (amount, currencyCode = "INR") => {
    const value = String(amount || "0").replace(/,/g, "");

    if (currencyCode === "INR") {
      return formatIndianNumber(Number(value).toFixed(2));
    }

    return formatInternationalNumber(Number(value).toFixed(2));
  };

  const sendNotification = async (notificationData) => {
    try {
      const { integrationToken } = useAuthStore.getState();

      if (!integrationToken) {
        console.error("Integration token missing");
        return;
      }

      const params = new URLSearchParams();

      params.append("from_userid", notificationData.from_userid?.toString());

      params.append("to_userid", notificationData.to_userid?.toString());

      params.append("message", notificationData.message || "");

      params.append("link", notificationData.link || "");

      params.append(
        "timestamp",
        notificationData.timespan || formatNotificationTime(),
      );

      const response = await axios.post(
        `${integrationBaseUrl}/api/notification_api`,
        params,
        {
          headers: {
            Authorization: `Bearer ${integrationToken}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      console.log("Notification sent:", response.data);
    } catch (error) {
      console.error(" Notification API failed:", error);
    }
  };
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };
  // useEffect(() => {
  //   if (!userId || !integrationBaseUrl) return;

  //   const fetchMatrix = async () => {
  //     try {
  //       setLoading(true);
  //       const res = await Regenerated_expireToken(async () => {
  //         const { integrationToken, integrationBaseUrl } =
  //           useAuthStore.getState();

  //         if (!integrationToken) {
  //           await useAuthStore.getState().generateIntegrationToken();
  //         }

  //         const params = new URLSearchParams();
  //         params.append("user_id", userId);
  //         params.append("department", department);
  //         params.append("location", location);
  //         params.append("document_type", "Expense");

  //         return await axios.post(
  //           `${integrationBaseUrl}/api/approval_matrix`,
  //           params,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${integrationToken}`,
  //               "Content-Type": "application/x-www-form-urlencoded",
  //             },
  //           },
  //         );
  //       });

  //       if (!res) return;

  //       const matrix = res.data?.data || [];

  //       console.log("Approval Matrix:", matrix);

  //       if (!matrix.length) {
  //         toastError("Approval matrix not available for this user");

  //         navigate(-1);

  //         return;
  //       }
  //       setApprovalMatrix(matrix);
  //       setHasMatrixAccess(true);

  //       setApprovalMatrix(matrix);
  //     } catch (err) {
  //       console.error("Approval Matrix failed", err);

  //       toastError("Failed to load approval matrix");

  //       navigate(-1);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchMatrix();
  // }, [
  //   userId,
  //   integrationBaseUrl,
  //   department,
  //   location,
  //   Regenerated_expireToken,
  //   employeeCode,
  //   navigate,
  // ]);
  const fetchApprovalMatrix = async (expenseType) => {
    if (!userId || !integrationBaseUrl) {
      toastError("User information is not available");
      return false;
    }

    try {
      setApprovalLoading(true);

      const res = await Regenerated_expireToken(async () => {
        const store = useAuthStore.getState();

        let { integrationToken, integrationBaseUrl } = store;

        if (!integrationToken) {
          await store.generateIntegrationToken();

          integrationToken = useAuthStore.getState().integrationToken;
        }

        const params = new URLSearchParams();

        params.append("user_id", userId);
        params.append("department", department);
        params.append("location", location);
        const documentType = approvalDocumentTypeMap[expenseType] || "Expense";

        params.append("document_type", documentType);

        return await axios.post(
          `${integrationBaseUrl}/api/approval_matrix`,
          params,
          {
            headers: {
              Authorization: `Bearer ${integrationToken}`,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
        );
      });

      if (!res) {
        return false;
      }

      const matrix = res.data?.data || [];

      if (!matrix.length) {
        toastError("Approval matrix not available for this expense type");

        setApprovalMatrix([]);
        return false;
      }

      setApprovalMatrix(matrix);
      setHasMatrixAccess(true);

      return true;
    } catch (error) {
      console.error("Approval Matrix failed:", error);

      toastError("Failed to load approval matrix");

      setApprovalMatrix([]);

      return false;
    } finally {
      setApprovalLoading(false);
    }
  };

  const handleExpenseTypeChange = async (e) => {
    const value = e.target.value;

    // Clear previous advance selections
    setAdvanceList([]);
    setSelectedAdvanceIds([]);

    if (!value) {
      setSelectedExpenseType("");
      setApprovalMatrix([]);
      setLines([{ ...emptyRow }]);
      return;
    }

    // ECAA - check advance balance BEFORE opening the form
    if (
      value === "expense_claim_against_apr" ||
      value === "return_again_advanced"
    ) {
      try {
        setApprovalLoading(true);

        const response = await axios.get(
          `${API_URL}/expense/${companyId}/advance-balance`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              user_id: userId,
              only_pending_balance: true,
            },
          },
        );

        const balance = Number(
          response?.data?.data?.summary?.total_balance_amount || 0,
        );

        if (balance <= 0) {
          toastError("No Open Advanced Payment Request");
          setSelectedExpenseType("");
          setApprovalMatrix([]);
          setLines([{ ...emptyRow }]);
          setAdvanceList([]);
          setSelectedAdvanceIds([]);
          return;
        }

        // Store all available advances for ECAA table
        setAdvanceList(response?.data?.data?.advances || []);
      } catch (error) {
        console.error("Advance balance API failed:", error);
        toastError("Failed to check advance balance");
        setSelectedExpenseType("");
        setApprovalMatrix([]);
        setLines([{ ...emptyRow }]);
        setAdvanceList([]);
        setSelectedAdvanceIds([]);
        return;
      } finally {
        setApprovalLoading(false);
      }
    }

    setSelectedExpenseType(value);

    if (
      value === "advanced_request_bank" ||
      value === "advanced_request_cash" ||
      value === "return_again_advanced"
    ) {
      const defaultCategory = getDefaultExpenseCategory(value);

      setLines([
        {
          ...emptyRow,
          expense_type_id: defaultCategory?.id
            ? String(defaultCategory.id)
            : "",
          gl_code: defaultCategory?.glcode || "",
          currency: defaultCategory?.currency || "INR",
          date: getTodayDate(),
        },
      ]);

      setOpenCategoryRow(null);
      setCategorySearch("");
    }

    const success = await fetchApprovalMatrix(value);
    if (!success) {
      setSelectedExpenseType("");
      setLines([{ ...emptyRow }]);
      return;
    }

    // ================= PT CASH BALANCE =================
    // Approval matrix is loaded first.
    // Cash balance will be checked when date + currency
    // are available in the form.
    if (value === "advanced_request_cash") {
      setCashBalance(null);
    }
  };
  const addRow = () => {
    if (
      selectedExpenseType === "advanced_request_bank" ||
      selectedExpenseType === "advanced_request_cash"
    ) {
      return;
    }

    setLines((prev) => [
      ...prev,
      {
        ...emptyRow,
        date: "",
      },
    ]);
  };
  const removeRow = (i) =>
    setLines((prev) => prev.filter((_, index) => index !== i));

  const updateLine = (i, field, value) => {
    setLines((prev) =>
      prev.map((l, index) => (index === i ? { ...l, [field]: value } : l)),
    );
  };
  // const handleAdvanceSelect = (advanceId) => {
  //   setSelectedAdvanceIds((prev) =>
  //     prev.includes(advanceId)
  //       ? prev.filter((id) => id !== advanceId)
  //       : [...prev, advanceId],
  //   );
  // };

  const handleAdvanceSelect = (advanceId) => {
    setSelectedAdvanceIds((prev) =>
      prev.includes(advanceId)
        ? prev.filter((id) => id !== advanceId)
        : [...prev, advanceId],
    );

    setReturnAmountError("");
    setReturnAmountErrorRow(null);
  };

  const groupedByCurrency = lines.reduce((acc, line, originalIndex) => {
    const currency = line.currency || "INR";

    if (!acc[currency]) {
      acc[currency] = [];
    }

    acc[currency].push({
      ...line,
      originalIndex,
    });

    return acc;
  }, {});
  const approvalDocumentTypeMap = {
    expense_claim: "Expense",
    advanced_request_cash: "Expense Advance/Return",
    advanced_request_bank: "Expense Advance/Return",
    expense_claim_against_apr: "Expense Claim APR",
    return_again_advanced: "Expense Advance/Return",
  };
  useEffect(() => {
    if (!companyId || !token) return;

    const fetchAllowDays = async () => {
      try {
        const res = await axios.get(`${API_URL}/allowdays/${companyId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const days = res?.data?.allowdays;

        if (days === undefined || days === null) {
          toastError("Allow Days not configured for company");
          setAllowDaysLimit(null);
          return;
        }

        setAllowDaysLimit(Number(days));
      } catch (error) {
        console.log("Allow days API error:", error);
        toastError("Failed to load allowed date range");
        setAllowDaysLimit(null);
      }
    };

    fetchAllowDays();
  }, [companyId, token]);
  useEffect(() => {
    if (
      !selectedExpenseType ||
      !expenseTypes.length ||
      !["advanced_request_cash", "advanced_request_bank"].includes(
        selectedExpenseType,
      )
    ) {
      return;
    }

    const defaultCategory = getDefaultExpenseCategory(selectedExpenseType);

    if (!defaultCategory) return;

    setLines((prev) => {
      if (!prev.length || prev[0].expense_type_id) {
        return prev;
      }

      return prev.map((line, index) =>
        index === 0
          ? {
              ...line,
              expense_type_id: String(defaultCategory.id),
              gl_code: defaultCategory.glcode || "",
              currency: defaultCategory.currency || "INR",
            }
          : line,
      );
    });
  }, [selectedExpenseType, expenseTypes]);
  // ================= SAFE DECIMAL CALCULATIONS =================

  const addAmounts = (amounts = []) => {
    let totalPaise = 0;

    amounts.forEach((value) => {
      // ✅ REMOVE COMMAS
      const clean = String(value || "0").replace(/,/g, "");

      // ✅ SPLIT DECIMAL
      const [rupees = "0", decimals = "00"] = clean.split(".");

      // ✅ FIX DECIMAL LENGTH
      const decimalValue = (decimals + "00").slice(0, 2);

      // ✅ CONVERT TO PAISE
      totalPaise += Number(rupees) * 100 + Number(decimalValue);
    });

    // ✅ RETURN FINAL
    return (totalPaise / 100).toFixed(2);
  };
  // ================= CASH LIMIT BALANCE =================

  const fetchCashLimitBalance = async (date, currencyCode) => {
    // Only applicable for PT / Advanced Request Cash
    if (selectedExpenseType !== "advanced_request_cash") {
      return null;
    }

    if (!companyId || !userId || !token || !date || !currencyCode) {
      return null;
    }

    try {
      setCashBalanceLoading(true);

      const response = await axios.get(
        `${API_URL}/company-cash-limit/${companyId}/balance/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            date,
            currency: currencyCode,
          },
        },
      );

      console.log("===== CASH LIMIT BALANCE RESPONSE =====");
      console.log(response.data);

      // API response:
      // response.data.data.limits[0].balance_amount

      const limit = response?.data?.data?.limits?.find(
        (item) =>
          String(item.currency).toUpperCase() ===
          String(currencyCode).toUpperCase(),
      );

      if (!limit) {
        console.warn(`No cash limit found for currency: ${currencyCode}`);

        setCashBalance(null);
        return null;
      }

      const availableBalance = Number(limit.balance_amount || 0);

      console.log("===== CASH BALANCE =====");
      console.log("Currency:", currencyCode);
      console.log("Cash Limit:", limit.cash_limit);
      console.log("Used Amount:", limit.used_amount);
      console.log("Balance Amount:", availableBalance);
      console.log("Can Add Expense:", limit.can_add_expense);

      setCashBalance(availableBalance);

      return availableBalance;
    } catch (error) {
      console.error("Cash limit balance API failed:", error);

      setCashBalance(null);

      return null;
    } finally {
      setCashBalanceLoading(false);
    }
  };

  const getSelectedAdvanceBalance = () => {
    return advanceList
      .filter((advance) =>
        selectedAdvanceIds.some((id) => String(id) === String(advance.id)),
      )
      .reduce(
        (total, advance) => total + Number(advance.balance_amount || 0),
        0,
      );
  };

  const formatIndianNumber = (value) => {
    if (!value) return "";

    const [integerPart, decimalPart] = String(value).split(".");

    const lastThree = integerPart.slice(-3);

    const otherNumbers = integerPart.slice(0, -3);

    const formattedInteger =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      (otherNumbers ? "," : "") +
      lastThree;

    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };

  const formatInternationalNumber = (value) => {
    if (!value) return "";

    const [integerPart, decimalPart] = String(value).split(".");

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return decimalPart !== undefined
      ? `${formattedInteger}.${decimalPart}`
      : formattedInteger;
  };
  // ================= VALIDATION =================
  const validateForm = () => {
    if (lines.length === 0) {
      toastWarning("Please add at least one expense line");
      return false;
    }
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      if (!line.expense_type_id) {
        toastError(`Row ${i + 1}: Please select a category`);
        return false;
      }

      if (!line.description) {
        toastWarning(`Row ${i + 1}: Please enter a description`);
        return false;
      }

      if (!line.amount || line.amount <= 0) {
        toastWarning(`Row ${i + 1}: Please enter a valid amount`);
        return false;
      }

      if (!line.date) {
        toastWarning(`Row ${i + 1}: Please select a date`);
        return false;
      }

      const selectedType = expenseTypes.find(
        (t) => String(t.id) === String(line.expense_type_id),
      );
      const limitAmount = getExpenseLimit(line.expense_type_id);

      if (limitAmount !== null) {
        const totalSameTypeDate = lines.reduce((sum, currentLine) => {
          const sameExpenseType =
            String(currentLine.expense_type_id) ===
            String(line.expense_type_id);

          const sameDate = String(currentLine.date) === String(line.date);

          if (sameExpenseType && sameDate) {
            return (
              sum + Number(String(currentLine.amount || "0").replace(/,/g, ""))
            );
          }

          return sum;
        }, 0);

        if (totalSameTypeDate > Number(limitAmount)) {
          toastError(
            `Row ${i + 1}: Total amount for category on ${
              line.date
            } cannot exceed ${
              line.currency || "INR"
            } ${formatAmount(limitAmount, line.currency)}`,
          );

          return false;
        }
      }

      if (
        Number(selectedType?.isattachmentrequired) === 1 &&
        !line.attachment
      ) {
        toastError(
          `Row ${i + 1}: Attachment is required for this expense type`,
        );
        return false;
      }
    }

    if (!approvalMatrix.length) {
      toastError("Approval matrix not available. Please try again.");
      return false;
    }
    if (!purpose.trim()) {
      toastWarning("Please enter purpose");
      return false;
    }
    return true;
  };

  // ================= UPLOAD FILES =================
  // const uploadFiles = async () => {
  //   if (files.length === 0) return [];

  //   const uploadedFiles = [];
  //   for (const file of files) {
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     formData.append("company_id", companyId.toString());
  //     formData.append("user_id", userId.toString());

  //     try {
  //       const response = await axios.post(`${API_URL}/upload`, formData, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       });

  //       if (response.data && response.data.file_path) {
  //         uploadedFiles.push(response.data.file_path);
  //       }
  //     } catch (error) {
  //       console.error("File upload error:", error);
  //       toastError(`Failed to upload file: ${file.name}`);
  //       throw error;
  //     }
  //   }
  //   return uploadedFiles;
  // };

  const handleSubmit = async () => {
    // Stop repeated clicks immediately
    if (submitLock.current) return;

    // Validate the form first
    if (!validateForm()) return;

    // RAA validation must run BEFORE locking submission
    // Paste the RAA validation block here.

    // Lock only after validation succeeds
    submitLock.current = true;
    setIsSubmitting(true);

    // Keep your existing PT cash balance validation
    // and API submission code below.

    // ECAA - total expense amount cannot exceed selected advance balance
    // if (
    //   selectedExpenseType === "expense_claim_against_apr" ||
    //   selectedExpenseType === "return_again_advanced"
    // ) {
    //   const selectedAdvanceBalance = advanceList
    //     .filter((advance) => selectedAdvanceIds.includes(advance.id))
    //     .reduce(
    //       (total, advance) => total + Number(advance.balance_amount || 0),
    //       0,
    //     );

    //   const totalExpenseAmount = Number(
    //     addAmounts(lines.map((line) => line.amount)),
    //   );

    //   if (totalExpenseAmount > selectedAdvanceBalance) {
    //     toastError(
    //       `Expense amount cannot exceed the available advance balance of ₹${selectedAdvanceBalance.toFixed(2)}`,
    //     );
    //     return;
    //   }
    // }

    // RAA - Return amount cannot exceed selected advance balance

    if (selectedExpenseType === "return_again_advanced") {
      if (selectedAdvanceIds.length === 0) {
        toastError("Please select at least one advance.");
        return;
      }

      const selectedAdvanceBalance = getSelectedAdvanceBalance();
      const totalReturnAmount = Number(
        addAmounts(lines.map((line) => line.amount)),
      );

      if (totalReturnAmount > selectedAdvanceBalance) {
        setReturnAmountErrorRow(0);

        toastError(
          `Return amount cannot exceed the selected advance balance of ${formatAmount(
            selectedAdvanceBalance,
            lines[0]?.currency || "INR",
          )}.`,
        );

        return;
      }

      setReturnAmountError("");
      setReturnAmountErrorRow(null);
    }

    submitLock.current = true;
    setIsSubmitting(true);

    submitLock.current = true;
    setIsSubmitting(true);
    // ================= PT CASH LIMIT FINAL CHECK =================
    if (selectedExpenseType === "advanced_request_cash") {
      const ptLine = lines[0];

      if (!ptLine?.date) {
        toastError("Please select a date for PT");
        return;
      }

      if (!ptLine?.currency) {
        toastError("Please select a currency for PT");
        return;
      }

      const requestedAmount = Number(
        String(ptLine.amount || "0").replace(/,/g, ""),
      );

      if (requestedAmount <= 0) {
        toastError("Please enter a valid Petty amount");
        return;
      }

      const latestBalance = await fetchCashLimitBalance(
        ptLine.date,
        ptLine.currency,
      );

      if (latestBalance === null) {
        toastError("Unable to verify Petty cash balance");
        return;
      }

      if (requestedAmount > Number(latestBalance)) {
        toastError(
          `You do not have sufficient balance for PT. Available balance: ${
            ptLine.currency
          } ${formatAmount(latestBalance, ptLine.currency)}`,
        );

        return;
      }
    }
    setIsSubmitting(true);

    try {
      // ================= UPLOAD FILES =================
      // let uploadedFilePaths = [];

      // try {
      //   uploadedFilePaths = await uploadFiles();
      // } catch (error) {
      //   toastError("File upload failed");
      //   setIsSubmitting(false);
      //   return;
      // }

      // ================= CONVERT LINE ATTACHMENTS =================
      let convertedAttachments = [];

      try {
        convertedAttachments = await Promise.all(
          lines.map(async (line) => {
            if (!line.attachment) return null;
            return await fileToBase64(line.attachment);
          }),
        );
      } catch (error) {
        toastError("Failed to process attachments");
        setIsSubmitting(false);
        return;
      }

      const isFinance = approvalMatrix.some((item) =>
        item.ta_type?.toLowerCase().includes("finance"),
      );

      // ================= MAIN ATTACHMENT =================
      // ================= MAIN ATTACHMENT =================
      let mainAttachment = null;

      if (files.length > 0) {
        try {
          mainAttachment = await fileToBase64(files[0]);
        } catch (error) {
          console.error("Failed to convert main attachment:", error);
          toastError("Failed to process header attachment");
          setIsSubmitting(false);
          return;
        }
      }
      // ================= PAYLOAD =================
      const payload = {
        company_id: companyId?.toString(),
        user_id: userId?.toString(),
        employee_code: employeeCode || userId?.toString(),
        purpose: purpose || "",
        currency: currency || "INR",
        user_grade: grade || "",
        total_amount: Number(addAmounts(lines.map((line) => line.amount))),

        // Selected request type code
        type: expenseTypeCodeMap[selectedExpenseType],

        description: description || "",
        attachment: mainAttachment,

        expense_lines: (selectedExpenseType === "advanced_request_bank" ||
        selectedExpenseType === "advanced_request_cash"
          ? lines.slice(0, 1)
          : lines
        ).map((l, index) => ({
          expense_type_id: Number(l.expense_type_id),
          description: l.description,
          date: l.date,
          currency: l.currency,
          total_amount: Number(addAmounts([l.amount])),
          attachment: convertedAttachments[index] || null,
          approved_amount: 0,
          remarks: "",
        })),

        approvals: (() => {
          const seenUserIds = new Set();

          return approvalMatrix
            .slice()
            .sort((a, b) => Number(a.serial_no) - Number(b.serial_no))
            .filter((item) => {
              const currentUserId = String(item.user_id);
              const taType = String(item.ta_type || "")
                .trim()
                .toLowerCase();

              if (taType === "purchase finance") {
                return true;
              }

              if (seenUserIds.has(currentUserId)) {
                return false;
              }

              seenUserIds.add(currentUserId);
              return true;
            })
            .map((a) => ({
              user_id: Number(a.user_id),
              username: a.username || "",
              status: a.level_name === "Initiated by" ? "Approved" : "Pending",
              serial_no: Number(a.serial_no),
              level_name: a.level_name || "",
              department: Number(a.department) || 0,
              department_name: a.department_name || "",
              designation: Number(a.designation) || 0,
              designation_name: a.designation_name || "",
              location: Number(a.location) || 0,
              location_name: a.location_name || "",
              isedituser:
                String(a.ta_type || "")
                  .trim()
                  .toLowerCase() === "purchase finance"
                  ? 1
                  : 0,
            }));
        })(),

        references: selectedAdvanceIds.map((id) => ({
          reference_id: id,
        })),
      };
      console.log("===== PAYLOAD =====");
      console.log(JSON.stringify(payload, null, 2));

      // ================= API CALL =================
      const response = await axios.post(
        `${API_URL}/expense/${companyId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const notificationData = response?.data?.data?.notification;

      if (notificationData) {
        await sendNotification({
          ...notificationData,
          timespan: formatNotificationTime(),
        });
      }

      toastSuccess("Expense claim submitted successfully!");
      resetForm();
      navigate("/requests/pending");
    } catch (error) {
      if (error.response) {
        toastError(
          error.response.data?.message ||
            error.response.data?.error ||
            `Server error: ${error.response.status}`,
        );
      } else if (error.request) {
        toastError("Network error. Please check your connection.");
      } else {
        toastError(error.message || "Something went wrong");
      }
    } finally {
      submitLock.current = false;
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!companyId || !token || !grade) return;

    const fetchExpenseGradeLimits = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/expense-grade-limit/${companyId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            params: {
              grades: grade,
            },
          },
        );

        setExpenseGradeLimits(response.data || []);
      } catch (error) {
        if (error.response) {
          toastError(
            error.response.data?.message ||
              "Failed to load expense grade limits",
          );
        } else {
          toastError("Network error while loading grade limits");
        }
      }
    };

    fetchExpenseGradeLimits();
  }, [companyId, token, grade]);
  // ================= RESET FORM =================
  const resetForm = () => {
    setLines([{ ...emptyRow }]);
    setFiles([]);
    setPurpose("");
    setDescription("");
  };

  const handleCancel = () => {
    navigate("/requests/all");
  };
  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollTop = tableRef.current.scrollHeight;
    }
  }, [lines.length]);
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const base64 = reader.result.split(",")[1];

        resolve({
          filename: file.name,
          base64: base64,
        });
      };

      reader.onerror = (err) => reject(err);
    });
  };
  const allowed_extensions = ["png", "jpg", "jpeg", "pdf", "xlsx", "xls"];

  const getFileExtension = (filename) =>
    filename.split(".").pop().toLowerCase();
  const getExpenseLimit = (expenseTypeId) => {
    const expenseType = expenseGradeLimits.find(
      (e) => String(e.expensetypeid) === String(expenseTypeId),
    );

    if (!expenseType) {
      return null;
    }

    const limitConfig = expenseType.limits?.find(
      (l) => String(l.expensegradecode) === String(grade),
    );

    if (
      !limitConfig ||
      !limitConfig.isconfigured ||
      limitConfig.limitamount === null ||
      limitConfig.limitamount === undefined ||
      limitConfig.limitamount === "N/A"
    ) {
      return null;
    }

    return Number(limitConfig.limitamount);
  };

  const getDefaultExpenseCategory = (expenseType) => {
    const categoryKeywords = {
      advanced_request_cash: ["cash advanced", "cash advance"],
      advanced_request_bank: ["bank advanced", "bank advance"],
      return_again_advanced: ["cash refund", "refund cash"],
    };

    const keywords = categoryKeywords[expenseType];

    if (!keywords) return null;

    return expenseTypes.find((item) => {
      if (Number(item.isactive) !== 1) return false;

      const categoryName = String(item.expensetypename || "")
        .trim()
        .toLowerCase();

      return keywords.some((keyword) => categoryName.includes(keyword));
    });
  };

  if (!hasMatrixAccess) {
    return null;
  }
  if (loading) {
    return (
      <div className="center-loader">
        <FaSpinner className="spinner" />
        <div>Loading...</div>
      </div>
    );
  }

  const getMinDate = () => {
    if (!allowDaysLimit) return null;

    const d = new Date();
    d.setDate(d.getDate() - allowDaysLimit);
    return d.toISOString().split("T")[0];
  };

  const getMaxDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const formatInputAmount = (amount, currency) => {
    if (!amount) return "";

    const clean = String(amount).replace(/,/g, "");

    if (currency === "INR") {
      return formatIndianNumber(clean);
    }

    return formatInternationalNumber(clean);
  };
  const getExpenseTypeLabel = (type) => {
    const normalizedType = String(type || "")
      .trim()
      .toUpperCase();

    const codeToTypeMap = {
      EC: "expense_claim",
      PT: "advanced_request_cash",
      BT: "advanced_request_bank",
      ECAA: "expense_claim_against_apr",
      RAA: "return_again_advanced",
    };

    const expenseTypeValue =
      codeToTypeMap[normalizedType] ||
      String(type || "")
        .trim()
        .toLowerCase();

    return (
      expenseRequestTypes.find((item) => item.value === expenseTypeValue)
        ?.label ||
      expenseTypeValue ||
      "-"
    );
  };
  const groupedRows = Object.entries(groupedByCurrency);
  let serialNumber = 0;
  return (
    <div className="newexpense-main-wrapper">
      <div className="newexpense-type-selection">
        <div className="newexpense-type-header"></div>

        <div className="expense-type-expenserow">
          <div className="newexpense-type-form">
            <label>
              Expense Type
              <span className="required-star">*</span>
            </label>

            {cashPermissionLoading ? (
              <div className="newexpense-approval-loading">
                <FaSpinner className="spinner" />
                <span>Checking permissions...</span>
              </div>
            ) : (
              <select
                value={selectedExpenseType}
                onChange={handleExpenseTypeChange}
                disabled={approvalLoading}
              >
                <option value="">Select Expense Type</option>

                {expenseRequestTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            )}

            {approvalLoading && (
              <div className="newexpense-approval-loading">
                <FaSpinner className="spinner" />
                <span>Loading approval matrix...</span>
              </div>
            )}
          </div>

          {selectedExpenseType && (
            <div className="expense-type-description">
              {
                expenseRequestTypes.find(
                  (type) => type.value === selectedExpenseType,
                )?.description
              }
            </div>
          )}
        </div>
      </div>

      {selectedExpenseType && (
        <>
          {/* ================= HEADER DETAILS ================= */}
          <div className="newexpense-header-details">
            {/* ROW 1 - FULL WIDTH */}
            <div className="newexpense-purpose-wrapper">
              <label className="newexpense-purpose-label">
                Purpose <span className="required-star">*</span>
              </label>

              <input
                type="text"
                className="newexpense-purpose-input"
                value={purpose}
                maxLength={250}
                onChange={(e) => setPurpose(e.target.value)}
                placeholder="Enter expense purpose"
              />

              <div className="newexpense-purpose-counter">
                {purpose.length}/250
              </div>
            </div>

            {/* ROW 2 - LEFT */}
            <div className="newexpense-description-wrapper">
              <label className="newexpense-purpose-label">Description</label>

              <textarea
                className="newexpense-description-input"
                value={description}
                maxLength={250}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter expense description"
              />

              <div className="newexpense-description-counter">
                {description.length}/250
              </div>
            </div>

            {/* ROW 2 - RIGHT */}
            <div className="newexpense-header-attachment">
              <label className="newexpense-purpose-label">Attachment</label>

              <input
                type="file"
                className="newexpense-header-file-input"
                accept=".png,.jpg,.jpeg,.pdf,.xls,.xlsx"
                onChange={(e) => {
                  const file = e.target.files?.[0];

                  if (!file) return;

                  const ext = getFileExtension(file.name);

                  if (!allowed_extensions.includes(ext)) {
                    toastError(
                      "Invalid file type. Allowed: png, jpg, jpeg, pdf, xlsx, xls",
                    );
                    e.target.value = "";
                    return;
                  }

                  const imageExtensions = ["png", "jpg", "jpeg"];

                  if (imageExtensions.includes(ext)) {
                    const maxSize = 2 * 1024 * 1024;

                    if (file.size > maxSize) {
                      toastError("Image size must be below 2 MB");
                      e.target.value = "";
                      return;
                    }
                  }

                  setFiles([file]);
                }}
              />
            </div>
          </div>
          {/* LINE ITEMS HEADER */}

          {(selectedExpenseType === "expense_claim_against_apr" ||
            selectedExpenseType === "return_again_advanced") &&
            advanceList.length > 0 && (
              <div className="advance-balance-section">
                <div className="advance-balance-title">Approved Advances</div>

                <div className="advance-balance-table-wrapper">
                  <table className="advance-balance-table">
                    <thead>
                      <tr>
                        <th>Select</th>
                        <th>Expense ID</th>
                        <th>Type</th>

                        <th>Request Amount</th>
                        <th>Approved Amount</th>
                        <th>Balance Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {advanceList.map((advance) => (
                        <tr key={advance.id}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedAdvanceIds.includes(advance.id)}
                              onChange={() => handleAdvanceSelect(advance.id)}
                              disabled={
                                Number(advance.balance_amount || 0) <= 0
                              }
                            />
                          </td>

                          <td>{advance.expense_id || "-"}</td>
                          <td>{getExpenseTypeLabel(advance.type)}</td>
                          <td>
                            {Number(advance.requested_amount || 0).toFixed(2)}
                          </td>
                          <td>
                            {Number(advance.approved_amount || 0).toFixed(2)}
                          </td>

                          <td>
                            {Number(advance.balance_amount || 0).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          <div className="newexpense-line-header-wrapper">
            <h3 className="newexpense-line-title">Line Items</h3>
          </div>
          <div className="newexpense-table-scroll" ref={tableRef}>
            <table className="newexpense-data-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    Category <span style={{ color: "red" }}>*</span>
                  </th>
                  <th>CUR</th>
                  <th>
                    Description <span style={{ color: "red" }}>*</span>{" "}
                  </th>
                  <th>
                    Date <span style={{ color: "red" }}>*</span>
                  </th>
                  <th>
                    Amount <span style={{ color: "red" }}>*</span>
                  </th>

                  <th>
                    Attachment
                    {lines.some((line) => {
                      const selectedType = expenseTypes.find(
                        (type) =>
                          String(type.id) === String(line.expense_type_id),
                      );

                      return Number(selectedType?.isattachmentrequired) === 1;
                    }) && <span style={{ color: "red" }}> *</span>}
                  </th>

                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {groupedRows.map(([currency, items]) => {
                  const total = addAmounts(items.map((item) => item.amount));
                  return (
                    <>
                      {items.map((line) => {
                        const rowIndex = line.originalIndex;

                        return (
                          <tr key={rowIndex}>
                            <td>{++serialNumber}</td>
                            {/* CATEGORY */}
                            <td style={{ position: "relative" }}>
                              {/* Select Box */}
                              <div
                                className="custom-select-box"
                                onClick={() => {
                                  setOpenCategoryRow(
                                    openCategoryRow === rowIndex
                                      ? null
                                      : rowIndex,
                                  );
                                }}
                              >
                                <span className="selected-category-text">
                                  {expenseTypes.find(
                                    (t) =>
                                      String(t.id) ===
                                      String(line.expense_type_id),
                                  )?.expensetypename || "Select Category"}
                                </span>
                                <FaChevronDown
                                  className={`dropdown-arrow ${
                                    openCategoryRow === rowIndex ? "rotate" : ""
                                  }`}
                                />
                              </div>

                              {/* Dropdown */}
                              {openCategoryRow === rowIndex && (
                                <div className="custom-dropdown">
                                  {/* Search */}
                                  <div className="dropdown-search-wrapper">
                                    <input
                                      autoFocus
                                      type="text"
                                      className="dropdown-search"
                                      placeholder="Search category..."
                                      value={categorySearch}
                                      onChange={(e) =>
                                        setCategorySearch(e.target.value)
                                      }
                                    />
                                  </div>

                                  {/* Options */}
                                  <div className="dropdown-list">
                                    {expenseTypes
                                      .filter((item) =>
                                        item.expensetypename
                                          .toLowerCase()
                                          .includes(
                                            categorySearch.toLowerCase(),
                                          ),
                                      )
                                      .map((item) => (
                                        <div
                                          key={item.id}
                                          className={`dropdown-item ${
                                            String(line.expense_type_id) ===
                                            String(item.id)
                                              ? "selected"
                                              : ""
                                          }`}
                                          onClick={async () => {
                                            const selectedCurrency =
                                              item.currency || "INR";

                                            updateLine(
                                              rowIndex,
                                              "expense_type_id",
                                              item.id,
                                            );
                                            updateLine(
                                              rowIndex,
                                              "gl_code",
                                              item.glcode || "",
                                            );
                                            updateLine(
                                              rowIndex,
                                              "currency",
                                              selectedCurrency,
                                            );

                                            setOpenCategoryRow(null);
                                            setCategorySearch("");

                                            // PT / Advanced Request Cash
                                            if (
                                              selectedExpenseType ===
                                                "advanced_request_cash" &&
                                              line.date
                                            ) {
                                              await fetchCashLimitBalance(
                                                line.date,
                                                selectedCurrency,
                                              );
                                            }
                                          }}
                                        >
                                          {item.expensetypename}
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              )}
                            </td>

                            <td>
                              <select
                                value={line.currency || ""}
                                onChange={async (e) => {
                                  const value = e.target.value;

                                  updateLine(rowIndex, "currency", value);

                                  if (
                                    selectedExpenseType ===
                                      "advanced_request_cash" &&
                                    line.date
                                  ) {
                                    await fetchCashLimitBalance(
                                      line.date,
                                      value,
                                    );
                                  }
                                }}
                              >
                                {currencyOptions.map((currency) => (
                                  <option key={currency} value={currency}>
                                    {currency}
                                  </option>
                                ))}
                              </select>
                            </td>

                            {/* DESCRIPTION */}
                            <td>
                              <input
                                value={line.description}
                                onChange={(e) =>
                                  updateLine(
                                    rowIndex,
                                    "description",
                                    e.target.value,
                                  )
                                }
                              />
                            </td>

                            {/* DATE */}
                            <td>
                              <input
                                type="date"
                                value={line.date}
                                min={
                                  selectedExpenseType ===
                                    "advanced_request_bank" ||
                                  selectedExpenseType ===
                                    "advanced_request_cash"
                                    ? getTodayDate()
                                    : getMinDate()
                                }
                                max={getMaxDate()}
                                disabled={
                                  !allowDaysLimit &&
                                  selectedExpenseType !==
                                    "advanced_request_bank" &&
                                  selectedExpenseType !==
                                    "advanced_request_cash"
                                }
                                onChange={async (e) => {
                                  const value = e.target.value;
                                  const today = getTodayDate();

                                  if (
                                    (selectedExpenseType ===
                                      "advanced_request_bank" ||
                                      selectedExpenseType ===
                                        "advanced_request_cash") &&
                                    value !== today
                                  ) {
                                    toastError(
                                      "For BT and PT, only today's date is allowed.",
                                    );
                                    return;
                                  }

                                  const min = getMinDate();
                                  const max = getMaxDate();

                                  if (
                                    selectedExpenseType !==
                                      "advanced_request_bank" &&
                                    selectedExpenseType !==
                                      "advanced_request_cash" &&
                                    (!min || value < min || value > max)
                                  ) {
                                    toastError(
                                      `Allowed date range is last ${allowDaysLimit} days only`,
                                    );
                                    return;
                                  }

                                  updateLine(rowIndex, "date", value);

                                  if (
                                    selectedExpenseType ===
                                      "advanced_request_cash" &&
                                    line.currency
                                  ) {
                                    await fetchCashLimitBalance(
                                      value,
                                      line.currency,
                                    );
                                  }
                                }}
                              />
                            </td>

                            <td>
                              <input
                                type="text"
                                inputMode="decimal"
                                placeholder="0.00"
                                value={formatInputAmount(
                                  line.amount,
                                  line.currency,
                                )}
                                className={`amount-input ${(() => {
                                  const limitAmount = getExpenseLimit(
                                    line.expense_type_id,
                                  );

                                  const exceedsGradeLimit =
                                    limitAmount !== null &&
                                    Number(
                                      String(line.amount || 0).replace(
                                        /,/g,
                                        "",
                                      ),
                                    ) > Number(limitAmount);

                                  const exceedsReturnBalance =
                                    selectedExpenseType ===
                                      "return_again_advanced" &&
                                    returnAmountErrorRow === rowIndex;

                                  return exceedsGradeLimit ||
                                    exceedsReturnBalance
                                    ? "amount-error-input"
                                    : "";
                                })()}`}
                                onChange={(e) => {
                                  let rawValue = e.target.value.replace(
                                    /,/g,
                                    "",
                                  );

                                  // Allow only numbers with max 2 decimal places
                                  if (!/^\d*\.?\d{0,2}$/.test(rawValue)) {
                                    return;
                                  }

                                  const limitAmount = getExpenseLimit(
                                    line.expense_type_id,
                                  );

                                  // ============================================================
                                  // EXPENSE GRADE LIMIT - CHECK IMMEDIATELY WHILE TYPING
                                  // ============================================================
                                  if (
                                    limitAmount !== null &&
                                    line.expense_type_id &&
                                    line.date
                                  ) {
                                    const totalSameTypeDate = lines.reduce(
                                      (sum, currentLine, idx) => {
                                        const sameExpenseType =
                                          String(
                                            currentLine.expense_type_id,
                                          ) === String(line.expense_type_id);

                                        const sameDate =
                                          String(currentLine.date) ===
                                          String(line.date);

                                        if (sameExpenseType && sameDate) {
                                          const amount =
                                            idx === rowIndex
                                              ? Number(rawValue || 0)
                                              : Number(
                                                  String(
                                                    currentLine.amount || "0",
                                                  ).replace(/,/g, ""),
                                                );

                                          return sum + amount;
                                        }

                                        return sum;
                                      },
                                      0,
                                    );

                                    // Even ₹0.01 / ₹1 above the limit will immediately show toast
                                    if (
                                      totalSameTypeDate > Number(limitAmount)
                                    ) {
                                      toastError(
                                        `Limit exceeded. Max ${
                                          line.currency || "INR"
                                        } ${formatAmount(limitAmount, line.currency)}`,
                                      );

                                      // IMPORTANT:
                                      // Do not update the input when limit is crossed
                                      return;
                                    }
                                  }

                                  const rawAmount = Number(rawValue || 0);

                                  // RAA: Reject an amount greater than the selected advance balance
                                  if (
                                    selectedExpenseType ===
                                    "return_again_advanced"
                                  ) {
                                    const selectedAdvanceBalance =
                                      getSelectedAdvanceBalance();

                                    if (rawAmount > selectedAdvanceBalance) {
                                      setReturnAmountErrorRow(rowIndex);

                                      toastError(
                                        `Return amount cannot exceed the selected advance balance of ${formatAmount(
                                          selectedAdvanceBalance,
                                          line.currency || "INR",
                                        )}.`,
                                      );

                                      return;
                                    }

                                    setReturnAmountErrorRow(null);
                                    setReturnAmountError("");
                                  }

                                  // ============================================================
                                  // UPDATE AMOUNT ONLY IF WITHIN LIMIT
                                  // ============================================================
                                  updateLine(rowIndex, "amount", rawValue);

                                  // ============================================================
                                  // PT CASH BALANCE - IMMEDIATE CHECK
                                  // ============================================================
                                  if (
                                    selectedExpenseType ===
                                      "advanced_request_cash" &&
                                    cashBalance !== null
                                  ) {
                                    const enteredAmount = Number(rawValue || 0);

                                    if (enteredAmount > Number(cashBalance)) {
                                      toastError(
                                        `You do not have sufficient balance for PT. Available balance: ${
                                          line.currency || "INR"
                                        } ${formatAmount(
                                          cashBalance,
                                          line.currency || "INR",
                                        )}`,
                                      );

                                      return;
                                    }
                                  }
                                }}
                                onBlur={async () => {
                                  if (line.amount !== "") {
                                    const formattedAmount = Number(
                                      String(line.amount).replace(/,/g, ""),
                                    ).toFixed(2);

                                    updateLine(
                                      rowIndex,
                                      "amount",
                                      formattedAmount,
                                    );

                                    // Re-check latest balance from backend
                                    if (
                                      selectedExpenseType ===
                                        "advanced_request_cash" &&
                                      line.date &&
                                      line.currency
                                    ) {
                                      const latestBalance =
                                        await fetchCashLimitBalance(
                                          line.date,
                                          line.currency,
                                        );

                                      if (
                                        latestBalance !== null &&
                                        Number(formattedAmount) >
                                          Number(latestBalance)
                                      ) {
                                        toastError(
                                          `You do not have sufficient balance for PT. Available balance: ${
                                            line.currency
                                          } ${formatAmount(
                                            latestBalance,
                                            line.currency,
                                          )}`,
                                        );

                                        return;
                                      }
                                    }
                                  }
                                }}
                              />

                              {/* {cashBalanceError &&
                                selectedExpenseType ===
                                  "advanced_request_cash" && (
                                  <div className="pt-cash-balance-error">
                                    {cashBalanceError}
                                  </div>
                                )} */}
                            </td>

                            {/* ATTACHMENT */}
                            <td>
                              <input
                                type="file"
                                accept=".png,.jpg,.jpeg,.pdf,.xls,.xlsx"
                                onChange={(e) => {
                                  const file = e.target.files?.[0];

                                  if (!file) return;

                                  const ext = getFileExtension(file.name);

                                  // ✅ allowed extensions
                                  if (!allowed_extensions.includes(ext)) {
                                    toastError(
                                      "Invalid file type. Allowed: png, jpg, jpeg, pdf, xlsx, xls",
                                    );

                                    e.target.value = "";

                                    return;
                                  }

                                  const imageExtensions = [
                                    "png",
                                    "jpg",
                                    "jpeg",
                                  ];

                                  if (imageExtensions.includes(ext)) {
                                    const maxSize = 2 * 1024 * 1024;

                                    if (file.size > maxSize) {
                                      toastError(
                                        "Image size must be below 2 MB",
                                      );

                                      e.target.value = "";

                                      return;
                                    }
                                  }

                                  updateLine(rowIndex, "attachment", file);
                                }}
                              />
                            </td>

                            {/* ACTION */}
                            <td>
                              <button onClick={() => removeRow(rowIndex)}>
                                ✕
                              </button>
                            </td>
                          </tr>
                        );
                      })}

                      {/* SUBTOTAL */}
                      {/* SUBTOTAL */}
                      <tr
                        key={`${currency}-total`}
                        className="newexpense-total-row"
                      >
                        {/* New first cell for Add Row button */}
                        <td className="total-add-row-cell">
                          {selectedExpenseType !== "advanced_request_bank" &&
                            selectedExpenseType !== "advanced_request_cash" && (
                              <button
                                type="button"
                                className="newexpense-add-row-btn"
                                onClick={addRow}
                              >
                                + Add
                              </button>
                            )}
                        </td>

                        <td colSpan="4">Total ({currency})</td>
                        <td>{formatAmount(total, currency)}</td>
                        <td colSpan="2"></td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* <div className="stepper-wrapper">
        {approvalMatrix
          .sort((a, b) => a.serial_no - b.serial_no)
          .map((a, i) => {
            const status = (a.status || "pending").toLowerCase();

            return (
              <div className="stepper-item" key={i}>
                {i !== 0 && <div className="stepper-line" />}

                <div className={`stepper-circle ${status}`}>
                  <img
                    src={
                      status === "approved"
                        ? approvedIcon
                        : status === "rejected"
                          ? rejectedIcon
                          : pendingIcon
                    }
                    className="stepper-icon"
                    alt=""
                  />
                </div>

                {i !== approvalMatrix.length - 1 && (
                  <div className="stepper-line" />
                )}

                <div className="stepper-content">
                  <div className="stepper-title-text">
                    {a.level_name || `Step ${i + 1}`}
                  </div>
                  <div className="stepper-name">{a.username}</div>
                </div>
              </div>
            );
          })}
      </div> */}
          <div className="newexpense-bottom-actions-bar">
            <button onClick={handleCancel}>Cancel</button>

            <button
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="newexpense-submit-btn"
            >
              {isSubmitting ? (
                <>
                  <FaSpinner className="spinner" />
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
